import { Icon, OptionList, Popover } from "@shopify/polaris";
import { ActivitiesMajor } from "@shopify/polaris-icons";
import React, { useCallback, useContext, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { ContextUser } from "src/context/ContextUser";
import { languages } from "src/types/i18next/i18n";

export function PopupLng() {
  const { i18n } = useTranslation();
  const { merchant } = useContext(ContextUser);
  const [open, setOpen] = useState(false);
  const toggleOpen = useCallback(() => setOpen(!open), [open]);

  const languageNames = new Intl.DisplayNames([], {
    type: "language",
  });

  useEffect(() => {
    const lng = window.localStorage.getItem("lng");
    if (lng) {
      i18n.changeLanguage(lng);
    } else {
      if (merchant) {
        i18n.changeLanguage(merchant.origin === "China" ? "zh" : "en");
      }
    }
  }, [i18n, merchant]);

  return (
    <Popover
      activator={
        <div className="Polaris-TopBar-Menu__ActivatorWrapper">
          <div
            onClick={toggleOpen}
            style={{ display: "flex", position: "relative", fontSize: "14pt", alignItems: "center" }}
            className="Polaris-TopBar-Menu__Activator"
          >
            <Icon source={ActivitiesMajor as any} />
            <span
              style={{
                position: "absolute",
                top: -15,
                zIndex: 100,
                right: -10,
              }}
            >
              <span
                style={{
                  padding: "2px 6px",
                  backgroundColor: "red",
                  color: "white",
                  borderRadius: "0.5rem",
                  fontSize: "10pt",
                  textTransform: "uppercase",
                }}
              >
                {i18n.language}
              </span>
            </span>
          </div>
        </div>
      }
      active={open}
      onClose={toggleOpen}
    >
      <Popover.Pane>
        <OptionList
          options={languages.map((x) => {
            return {
              label: languageNames.of(x),
              value: x,
            };
          })}
          selected={[i18n.language]}
          onChange={(value) => {
            window.localStorage.setItem("lng", value[0]);
            i18n.changeLanguage(value[0]);
          }}
          allowMultiple={false}
        />
      </Popover.Pane>
    </Popover>
  );
}
